import { IHusstSortGroup, HUSST_SORT_GROUPS } from '@web/dtos';
import { API_RESPONSE_SCHEMA, IApiResponse } from '@web/shared-types';
import { Observable } from 'rxjs';
import { RestCallBuilder } from '../../../builder/rest/rest-call.builder';
import { AppConfigService } from '../../app-config.service';
import { inject } from '@angular/core';

export class SortGroupsGateway {
  private readonly configService: AppConfigService = inject(AppConfigService);
  private readonly restCallBuilder: RestCallBuilder<IHusstSortGroup[]> =
    new RestCallBuilder<IHusstSortGroup[]>([]);

  list(sortGroupType?: string, serviceAreaId?: number): Observable<IApiResponse<IHusstSortGroup[]>> {
    const params: Record<string, any> = {};
    if (sortGroupType) params['sortGroupType'] = sortGroupType;
    if (serviceAreaId) params['serviceAreaId'] = serviceAreaId;

    return this.restCallBuilder
      .getExternal(
        this.configService.get().general.tariffUrl + '/tariff/sort-groups',
        params
      )
      .validate(API_RESPONSE_SCHEMA(HUSST_SORT_GROUPS), 'SortGroups.list')
      .handleMessages()
      .build();
  }
}
